import { z } from 'zod';

/** Mirrors apps/api/src/modules/identity/http/platform-admin.dto.ts (`crossTenantReasonSchema`) — same bounds, same field names. */
export const membershipLookupFormSchema = z.object({
  userId: z.string().trim().uuid('Identifiant utilisateur invalide (UUID attendu).'),
  reason: z.string().trim().min(10, 'Le motif doit contenir au moins 10 caractères.').max(500),
});
export type MembershipLookupFormValues = z.infer<typeof membershipLookupFormSchema>;
